import apiClient from './api_client_requests';

export default config => {
    return async payload => {
        // const userSessionKey = 'wa360_session'; //? unused
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const getTopLevelDomain = domain => {
            // this should return only the
            // extension and the top level of the domain
            // ex: futurewalottery.com
            // from stg01.mylottery360.futurewalottery.com
            return domain
                .split('.')
                .slice(-2)
                .join('.');
        };

        const setCookieValueByName = (cookieName, cookieValue) => {
            if (typeof document === 'undefined') {
                return;
            }

            document.cookie = `${cookieName}=${cookieValue}; Path=/; Domain=${getTopLevelDomain(
                document.location.hostname
            )}`;
            return cookieValue;
        };

        let result = await apiClient(config).apiMethod({
            method: 'PlayerLogin',
            args: {
                email: payload.email,
                password: payload.password,
                login_type: 'desktop',
                remember: true,
            },
        });

        let player = result.player;
        let loggedIn = player ? true : false;
        if (loggedIn) {
            setCookieValueByName(appCookieKey, result.token);
            let cookie = JSON.stringify({
                token: result.token,
                spat: result.spat,
                expires: '',
            });
            setCookieValueByName(sharedCookieKey, cookie);

            return {
                loggedIn: loggedIn,
                player: {
                    name: player.firstname + ' ' + player.lastname,
                    email: player.email,
                    first_name: player.firstname,
                    last_name: player.lastname,
                    email_confirm: player.email,
                },
            };
        } else if (result.code) {
            return {
                loggedIn: false,
                errors: result.code,
            };
        } else {
            return {
                loggedIn: false,
                errors: 'Unspecified Error',
            };
        }
    };
};
